import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Search for student accounts that may be duplicates. Enter <strong>names</strong> or <strong>emails</strong> to locate matching records." id="search_for_student_accounts_that_may_be.69a44758" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Finding Duplicates" id="finding_duplicates.e9c68300" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Select the accounts to merge and choose which record to keep as the <strong>primary</strong>. All data from the secondary account will be consolidated into the primary." id="select_the_accounts_to_merge_and_choose.dc31fe1e" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Merging Accounts" id="merging_accounts.4fe1422c" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Merging is <strong>permanent</strong> and cannot be undone. Review the selected accounts carefully before confirming the merge." id="merging_is_permanent_and_cannot_be_undon.77bec63a" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Important Notes" id="important_notes.a3e974ae" />
        }
    ],
    title: <FormattedMessage defaultMessage="Merge Students" id="merge_students.8704ea51" />
};
